import { Controller } from "@hotwired/stimulus"
import { loadBundle } from "../utils/lazy_bundle"

// Attached to every Chartkick placeholder div by the `html` option in
// config/initializers/chartkick.rb.
//
// Chartkick renders an inline <script> per chart that draws immediately if
// `window.Chartkick` exists and otherwise waits for a `chartkick:load` event.
// Since Chartkick now ships inside the on-demand highcharts bundle, something
// has to ask for it — that's this controller. It exists so the admin dashboards
// keep working without putting 575KB of Highcharts on every other page.
export default class extends Controller {
  connect() {
    loadBundle("highcharts").catch(error => console.error(error))
  }
}
